import { useTranslation } from "react-i18next";

interface EmptyStateProps { }

export function EmptyState({ }: EmptyStateProps) {
  const { t } = useTranslation();

  return (
    <div className="text-center py-8">
      <div className="text-gray-500">{t("knowledgeBase.noFiles")}</div>
    </div>
  );
}